import * as z from "zod";

import { zodNumberFieldOptional } from "@js/rhf/schemas";

export const rostersFiltersSchema = z.object({
  search: z.string().nullish(),
  visibility: z.string().nullish(),
  page: zodNumberFieldOptional,
});

export type RostersFiltersFormValues = z.infer<typeof rostersFiltersSchema>;
